module.exports = __webpack_public_path__ + "img/video.ba093572.png";